import React, { useEffect, useState } from 'react';
import Modal from 'src/shared/components/modal/Modal';
import { Badge } from 'src/shared/components/ui/badge';
import { SpeciesImage } from 'src/app/portfolio/components/species-image/SpeciesImage';
import IUCNStatusChip from 'src/shared/components/iucn-status-chip';
import { IUCNStatusCode } from 'src/shared/helpers/iucnStatusHelper';
import { getConfidenceDetail } from 'src/shared/helpers/speciesConfidence';
import cmsService from 'src/services/cms-service';

type Props = {
    onClose: () => void;
    scientificName: string;
    commonName?: string | null;
    iucnCategory: string;
    confidence?: string | null;
};

const SpeciesInfoModal = ({ onClose, scientificName, commonName, iucnCategory, confidence }: Props) => {
    const confidenceDetail = getConfidenceDetail(confidence);
    const [bio, setBio] = useState<string | null>(null);

    useEffect(() => {
        cmsService.getSpeciesByScientificName(scientificName, 'fields[0]=description').then(details => {
            setBio(details?.description ?? null);
        });
    }, [scientificName]);

    return (
        <Modal dismissOnClickOutside={true} classNames={{ body: 'w-[520px] p-6' }} onClose={onClose}>
            <div data-testid='species-info-modal' className='flex flex-col gap-4'>
                <div className='flex flex-row gap-4'>
                    <SpeciesImage
                        scientificName={scientificName}
                        alt={commonName || scientificName}
                        width='202px'
                        height='113px'
                        className='rounded-lg'
                    />
                    <div className='flex flex-col gap-1'>
                        <div className='text-3xl text-primary'>{commonName || scientificName}</div>
                        {commonName && <div className='text-base italic text-grey-80'>({scientificName})</div>}
                        <div className='flex flex-row items-center gap-2'>
                            <IUCNStatusChip status={iucnCategory.toUpperCase() as IUCNStatusCode} className='text-xs' />
                            {confidence && <Badge className={confidenceDetail.colorClass}>{confidenceDetail.label}</Badge>}
                        </div>
                    </div>
                </div>
                {bio && (
                    <div className='flex flex-col gap-2 rounded-lg border border-grey-20 p-4'>
                        <div className='text-xl'>Species Bio</div>
                        <div className='text-sm text-grey-80' dangerouslySetInnerHTML={{ __html: bio }} />
                    </div>
                )}
            </div>
        </Modal>
    );
};

export default SpeciesInfoModal;
